(() => {
  const initialize = (root) => {
    if (root.dataset.voicesReady) return;
    const cards = [...root.querySelectorAll('[data-voice]')];
    const tools = root.querySelector('[data-voices-tools]');
    const filters = [...root.querySelectorAll('[data-voice-filter]')];
    const search = root.querySelector('[data-voice-search]');
    const status = root.querySelector('[data-voice-status]');
    const more = root.querySelector('[data-voice-more]');
    const moreWrap = root.querySelector('[data-voice-more-wrap]');
    const empty = root.querySelector('[data-voice-empty]');
    const dialog = root.querySelector('[data-voice-dialog]');
    if (!cards.length || !tools || !search || !status || !more || !moreWrap || !empty) return;
    root.dataset.voicesReady = 'true';
    const normalize = (value) => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const records = cards.map((card) => ({
      card,
      categories: (card.dataset.categories || 'other').split(' '),
      searchText: normalize(card.dataset.search || card.textContent)
    }));
    const step = 24;
    let category = 'all';
    let visibleCount = step;
    let matching = records;
    let searchTimer;
    let opener;

    filters.forEach((button) => {
      const value = button.dataset.voiceFilter;
      if (value !== 'all' && !records.some((record) => record.categories.includes(value))) button.hidden = true;
    });

    const update = () => {
      const words = normalize(search.value.trim()).split(/\s+/).filter(Boolean);
      matching = records.filter((record) =>
        (category === 'all' || record.categories.includes(category)) && words.every((word) => record.searchText.includes(word))
      );
      const visible = new Set(matching.slice(0, visibleCount).map((record) => record.card));
      cards.forEach((card) => { card.hidden = !visible.has(card); });
      filters.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.voiceFilter === category)));
      const shown = Math.min(visibleCount, matching.length);
      status.textContent = matching.length === records.length
        ? `${shown} of ${records.length} comments`
        : `${shown} of ${matching.length} matching comments`;
      moreWrap.hidden = shown >= matching.length;
      empty.hidden = matching.length > 0;
    };

    const revealMore = (moveFocus = false) => {
      if (visibleCount >= matching.length) return;
      const firstNew = matching[visibleCount]?.card;
      visibleCount += step;
      update();
      if (moveFocus) firstNew?.querySelector('a')?.focus();
    };

    filters.forEach((button) => button.addEventListener('click', () => {
      category = button.dataset.voiceFilter;
      visibleCount = step;
      update();
    }));
    search.addEventListener('input', () => {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(() => { visibleCount = step; update(); }, 120);
    });
    more.addEventListener('click', () => revealMore(true));
    root.querySelector('[data-voice-reset]')?.addEventListener('click', () => {
      search.value = '';
      category = 'all';
      visibleCount = step;
      update();
      search.focus();
    });

    if (dialog && typeof dialog.showModal === 'function') {
      root.addEventListener('click', (event) => {
        const link = event.target.closest('[data-voice-capture]');
        if (!link || !root.contains(link) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const card = link.closest('[data-voice]');
        const fullImage = dialog.querySelector('[data-voice-dialog-image]');
        const source = card.querySelector('[data-voice-source]');
        fullImage.src = link.href;
        fullImage.alt = link.querySelector('img')?.alt || 'Original comment screenshot';
        fullImage.width = Number(link.dataset.width) || 960;
        fullImage.height = Number(link.dataset.height) || 720;
        dialog.querySelector('[data-voice-dialog-title]').textContent = `${card.dataset.author} on ${card.dataset.platform}`;
        dialog.querySelector('[data-voice-dialog-source]').href = source.href;
        opener = link;
        dialog.showModal();
        dialog.scrollTop = 0;
        dialog.querySelector('[data-voice-close]').focus();
      });
      dialog.querySelector('[data-voice-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => {
        dialog.querySelector('[data-voice-dialog-image]').removeAttribute('src');
        opener?.focus({ preventScroll: true });
      });
    }

    tools.hidden = false;
    update();
    const sentinel = root.querySelector('[data-voice-sentinel]');
    if ('IntersectionObserver' in window && sentinel) {
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) revealMore();
      }, { rootMargin: '400px 0px' });
      observer.observe(sentinel);
      root.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
    }
  };
  const scan = (scope) => {
    if (scope.matches?.('[data-voices]')) initialize(scope);
    scope.querySelectorAll('[data-voices]').forEach(initialize);
  };
  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
